<template>
  <div class="container">
    <div v-bind:class="[data.id%2 == 0 ? 'row d-flex flex-row-reverse':'row d-flex']">
      <div class="col-md-6 col-xs-12 imgBox">
        <h1>{{ data.title }}</h1>
        <img :src="data.img" alt="" />
      </div>
      <div class="col-md-6 col-xs-12 txtBox">
        <p>
          {{ data.content }}
        </p>
        <ul>
          <li v-for="(item, i) in data.list" v-bind:key="i">{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "itemServices",
  props: {
    data: {
      type: Object,
      required: true,
    },
  }
};
</script>

<style lang="css" scoped>
.container{
  padding:50px 0;
}
.imgBox {
  text-align: center;
}
.imgBox h1 {
  text-align: left;
  color: var(--primary);
  border-bottom: 2px solid var(--primary);
}
.imgBox img {
  box-sizing: border-box;
  width: auto;
  min-height: 40vh;
}
.txtBox {
  padding: 50px;
  margin: 0 auto;
}
</style>
